<template>
  <div
    class="home"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <!-- PC头部 -->
    <div class="homeTop hidden-xs-only">
      <Pic-top></Pic-top>
      <div class="homeTopList">
        <div class="left eng_left">
          <div class="navbar_dropdown_group" @click="handleChange(1)">
            <router-link to="index" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 1 ? 'selected' : 'sele'"
              >
                Home
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(2)">
            <router-link to="exhibition" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 2 ? 'selected' : 'sele'"
              >
                Regong Works Exhibition
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(4)">
            <router-link to="exhibitionSale" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 4 ? 'selected' : 'sele'"
              >
                Regong Exhibition and Sales
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(5)">
            <router-link to="culture" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 5 ? 'selected' : 'sele'"
              >
                Cultural and Creative Design Exhibition and Sales
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(3)">
            <router-link to="database" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 3 ? 'selected' : 'sele'"
              >
                Database
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(12)">
            <router-link to="inherit" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 12 ? 'selected' : 'sele'"
              >
                Inheritor
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(9)">
            <router-link to="news" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 9 ? 'selected' : 'sele'"
              >
                News Updates
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(10)">
            <router-link to="about" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 10 ? 'selected' : 'sele'"
              >
                About Us
              </div>
            </router-link>
          </div>
          <div class="searchInput hidden-xs-only">
            <el-select
              :popper-append-to-body="false"
              popper-class="select-popper"
              v-model="Info.type"
              placeholder="Select"
              @change="handleSelectChange"
            >
              <el-option
                v-for="item in typeEnglishList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input v-if="Info.type == 1||Info.type == 2||Info.type == ''" v-model="Info.name" @input="handleInputChange" placeholder="Please enter content"></el-input>
            <el-select
              v-else
              popper-class="select-popper"
              class="inheritor" 
              @focus="clearReadonly"
              @hook:mounted="clearReadonly"
              @visible-change="clearReadonly"
              ref="agentSelect"
              @change="handleInheritChange()" 
              clearable 
              v-model="Info.inheritorId" 
              filterable 
              placeholder="Please enter content">
              <el-option
                v-for="item in inheritData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <div class="searchButton" v-if="Info.type == 1||Info.type == 2" @click="handSearchOther()">
              <img src="../../assets/newImageBgc/search.png" alt="" />
            </div>
          </div>
          <div class="change">
            <el-select :popper-append-to-body="false" popper-class="select-popper" @change="changePCLanguages()" v-model="language" placeholder="请选择">
              <el-option
                v-for="item in languageList"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机版头部 -->
    <div class="menu_mobile hidden-sm-and-up">
      <div class="header_mobile_title">
        <img
          class="backImg"
          @click="goBack"
          src="../../assets/mobile/back.png"
          alt=""
        />
        <el-select
          :popper-append-to-body="false"
          popper-class="select-popper"
          v-model="mobileInfo.type"
          placeholder="Select"
          @change="handleSelectChange"
        >
          <el-option
            v-for="item in typeEnglishList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-if="mobileInfo.type == 1||mobileInfo.type == 2||mobileInfo.type == ''"
          class="searchMobileInput"
          placeholder="Please enter content"
          v-model="mobileInfo.name"
          @input="handleInputMobileChange"
        >
        </el-input>
        <el-select
          v-else
          popper-class="select-popper"
          class="inheritor" 
          @focus="clearReadonly"
          @hook:mounted="clearReadonly"
          @visible-change="clearReadonly"
          ref="agentSelect"
          @change="handleInheritChange()" 
          clearable 
          v-model="mobileInfo.inheritorId" 
          filterable placeholder="Please enter content">
          <el-option
            v-for="item in inheritData"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="searchButton eng_header_mobile_title" @click="mobileSearch">
          Search
        </div>
      </div>
      <!-- 导航栏 -->
      <div class="header_mobile_content" style="display: none">
        <div class="mobile_content_top">
          <span></span>
        </div>
        <div class="mobile_content_middle">
          <div>
            <div @click="handleChange(1)">
              <router-link to="index">Home</router-link>
            </div>
            <div @click="handleChange(2)">
              <router-link to="exhibition">Regong Works Exhibition</router-link>
            </div>
            <div @click="handleChange(4)">
              <router-link to="exhibitionSale"
                >Regong Exhibition and Sales</router-link
              >
            </div>
            <div @click="handleChange(5)">
              <router-link to="culture"
                >Cultural and Creative Design Exhibition and Sales</router-link
              >
            </div>
            <div @click="handleChange(3)">
              <router-link to="database">Database</router-link>
            </div>
            <div @click="handleChange(9)">
              <router-link to="news">News Updates</router-link>
            </div>
            <div @click="handleChange(10)">
              <router-link to="about">About Us</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <Pic-top></Pic-top>
    </div>
    <div class="dataBaseSearchTop hidden-xs-only">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale"
            >Regong Exhibition and Sales</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ eng_pcsearchName }}</span>
        </div>
      </div>
    </div>
    <div class="dataBaseSearchTop hidden-sm-and-up">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale"
            >Regong Exhibition and Sales</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ eng_pcsearchName }}</span>
        </div>
      </div>
    </div>
    <div class="dataBaseSearchContent">
      <div class="section">
        <div class="saleTopList">
          <div
            class="item"
            v-for="(item, index) in saleTopList"
            :key="index"
            @click="chooseCategory(item.id)"
          >
            <img class="img" :src="item.imgSrc" alt="" />
            <span class="title eng_title">{{ item.eng_title }}</span>
            <div :class="isClick == item.id ? 'isClick' : ''"></div>
          </div>
        </div>
        <div class="waterfallBox hidden-xs-only" v-if="cardList.length !== 0">
          <div
            class="exhibitionSearchItem"
            @click="goDetail(item.id)"
            v-for="(item, index) in cardList"
            :key="index"
          >
            <img
              class="image"
              v-if="item.watermark.length>0"
              :src="url + item.watermark[0].fileUrl"
              alt="加载错误"
            />
            <img class="image" v-else src="" alt="暂无图片" />
            <div class="ItemBody">
              <img
                class="imageHead"
                v-if="item.authorPicture"
                :src="url + item.authorPicture.thinUrl"
              />
              <span class="noneImage" v-else></span>
              <div class="ItemBody_name">{{ item.englishName }}</div>
            </div>
          </div>
        </div>
        <div class="noMessage hidden-xs-only" v-if="cardList.length == 0 && !loading">
          none
        </div>
        <div class="waterfallBox hidden-sm-and-up">
          <div
            class="mobileExhibitionSearchItem"
            @click="goDetail(item.id)"
            v-for="(item, index) in cardListMobile"
            :key="index"
          >
            <img
              class="image"
              v-if="item.watermark.length>0"
              :src="url + item.watermark[0].fileUrl"
              alt="加载错误"
            />
            <img class="image" v-else src="" alt="暂无图片" />
            <div class="ItemBody">
              <img
                class="imageHead"
                v-if="item.authorPicture"
                :src="url + item.authorPicture.thinUrl"
              />
              <span class="noneImage" v-else></span>
              <div class="ItemBody_name">{{ item.englishName }}</div>
            </div>
          </div>
          <div
            class="noMessage hidden-sm-and-up"
            v-if="cardListMobile.length == 0 && !loading"
          >
            none
          </div>
        </div>
        <div
          class="loading"
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
        ></div>
      </div>
      <img
        class="CloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="exhibitionSearchBottom">
      <div class="section wow animate__fadeInUp animate__animated">
        <div class="customMadeLeft">
          <div class="high eng_high">High-end customization</div>
          <p>
            Customization description: Customization means tailoring for
            individual customers. Savile Row is a shopping district in central
            Mayfair, London, known for its traditional custom men's clothing
            industry. With the development of the times, the meaning of the word
            "customization" has gradually been enriched, such as customized
            clothing, gifts, and even customized skin color, vegetable
            formulations, etc., catering to people's pursuit of quality and
            personality. Customization is the true personalized consumption.
          </p>
        </div>
        <div class="customMadeRight eng_customMadeRight">
          <div>Customize immediately for exclusive customization</div>
        </div>
      </div>
    </div>
    <!-- 公共底部 -->
    <common-bottom></common-bottom>
    <div class="contact">
      <div class="made" @click="goExhibitionMade()">
        <img src="../../assets/exhibitionsale/user.png" alt="" />
        <div>Customized Work</div>
      </div>
      <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">Contact Number：{{templeContact}}</div>
        <div class="tel">Email：hn_regong_ca@163.com</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>Contact art studio</div>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
  <div class="home" v-else-if="this.language == 'en'">
    <!-- PC头部 -->
    <div class="homeTop hidden-xs-only">
       <Pic-top></Pic-top>
      <div class="homeTopList">
        <div class="left za_left">
          <div class="navbar_dropdown_group" @click="handleChange(1)">
            <router-link to="index" active-class="tarbar" class="tar">
              <div class="tarbar_title" :class="{ selected: active == 1 }">
                ངོ་བྱང་།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(2)">
            <router-link to="exhibition" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 2 ? 'selected' : 'sele'"
              >
                རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(4)">
            <router-link to="exhibitionSale" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 4 ? 'selected' : 'sele'"
              >
                རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་འཚོང་།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(5)">
            <router-link to="culture" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 5 ? 'selected' : 'sele'"
              >
                རིག་གཏོད་ཇུས་འགོད་དང་འགྲེམ་འཚོང་།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(3)">
            <router-link to="database" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 3 ? 'selected' : 'sele'"
              >
                གྲངས་མཛོད།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(12)">
            <router-link to="inherit" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 12 ? 'selected' : 'sele'"
              >
                རྒྱུན་འཛིན་པ།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(9)">
            <router-link to="news" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 9 ? 'selected' : 'sele'"
              >
                གསར་འགྱུར་གྱི་གནས་ཚུལ།
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(10)">
            <router-link to="about" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 10 ? 'selected' : 'sele'"
              >
                ང་ཚོའི་སྐོར།
              </div>
            </router-link>
          </div>
          <div class="searchInput hidden-xs-only">
            <el-select
              :popper-append-to-body="false"
              popper-class="select-popper"
              v-model="Info.type"
              placeholder="གདམ་གསེས།"
              @change="handleSelectChange"
            >
              <el-option
                v-for="item in typeZangList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
             v-if="Info.type == 1||Info.type == 2||Info.type == ''"
              v-model="Info.name"
              placeholder="ནང་དོན་རོགས་།"
              @input="handleInputChange"
            ></el-input>
            <el-select
              v-else
              popper-class="select-popper"
              class="inheritor" 
              @focus="clearReadonly"
              @hook:mounted="clearReadonly"
              @visible-change="clearReadonly"
              ref="agentSelect"
              @change="handleInheritChange()" clearable v-model="Info.inheritorId" filterable placeholder="གདམ་གསེས།">
              <el-option
                v-for="item in inheritData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <div class="searchButton" v-if="Info.type == 1||Info.type == 2" @click="handSearchOther()">
              <img src="../../assets/newImageBgc/search.png" alt="" />
            </div>
          </div>
          <div class="change">
            <el-select :popper-append-to-body="false" popper-class="select-popper" @change="changePCLanguages()" v-model="language" placeholder="请选择">
              <el-option
                v-for="item in languageList"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机版头部 -->
    <div class="menu_mobile hidden-sm-and-up">
      <div class="header_mobile_title">
        <img
          class="backImg"
          @click="goBack"
          src="../../assets/mobile/back.png"
          alt=""
        />
        <el-select
          :popper-append-to-body="false"
          popper-class="select-popper"
          v-model="mobileInfo.type"
          placeholder="གདམ་གསེས།"
          @change="handleSelectChange"
        >
          <el-option
            v-for="item in typeZangList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-if="mobileInfo.type == 1||mobileInfo.type == 2||mobileInfo.type == ''"
          class="searchMobileInput"
          placeholder="ནང་དོན་རོགས་།"
          v-model="mobileInfo.name"
          @input="handleInputMobileChange"
        >
        </el-input>
        <el-select
          popper-class="select-popper"
          v-else
          class="inheritor" 
          @focus="clearReadonly"
          @hook:mounted="clearReadonly"
          @visible-change="clearReadonly"
          ref="agentSelect"
          @change="handleInheritChange()" clearable v-model="mobileInfo.inheritorId" filterable placeholder="ནང་དོན་རོགས་།">
          <el-option
            v-for="item in inheritData"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="searchButton" @click="mobileSearch">འཚོལ་བཤེར།</div>
      </div>
      <!-- 导航栏 -->
      <div class="header_mobile_content" style="display: none">
        <div class="mobile_content_top">
          <span></span>
        </div>
        <div class="mobile_content_middle">
          <div>
            <div @click="handleChange(1)">
              <router-link to="index">ངོ་བྱང་།</router-link>
            </div>
            <div @click="handleChange(2)">
              <router-link to="exhibition">
                རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ།
              </router-link>
            </div>
            <div @click="handleChange(4)">
              <router-link to="exhibitionSale"
                >རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་འཚོང་།
              </router-link>
            </div>
            <div @click="handleChange(5)">
              <router-link to="culture"
                >རིག་གཏོད་ཇུས་འགོད་དང་འགྲེམ་འཚོང་།</router-link
              >
            </div>
            <div @click="handleChange(3)">
              <router-link to="database"> གྲངས་མཛོད།</router-link>
            </div>
            <div @click="handleChange(9)">
              <router-link to="news"> གསར་འགྱུར་གྱི་གནས་ཚུལ།</router-link>
            </div>
            <div @click="handleChange(10)">
              <router-link to="about">ང་ཚོའི་སྐོར།</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
       <Pic-top></Pic-top>
    </div>
    <div class="dataBaseSearchTop hidden-xs-only">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale"
            >རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་འཚོང་།</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ za_pcsearchName }}</span>
        </div>
      </div>
    </div>
    <div class="dataBaseSearchTop hidden-sm-and-up">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale"
            >རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་འཚོང་།</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ za_pcsearchName }}</span>
        </div>
      </div>
    </div>
    <div class="dataBaseSearchContent">
      <div class="section">
        <div class="saleTopList">
          <div
            class="item"
            v-for="(item, index) in saleTopList"
            :key="index"
            @click="chooseCategory(item.id)"
          >
            <img class="img" :src="item.imgSrc" alt="" />
            <span class="title">{{ item.za_title }}</span>
            <div :class="isClick == item.id ? 'isClick' : ''"></div>
          </div>
        </div>
        <div class="waterfallBox hidden-xs-only" v-if="cardList.length !== 0">
          <div
            class="exhibitionSearchItem"
            @click="goDetail(item.id)"
            v-for="(item, index) in cardList"
            :key="index"
          >
            <img
              class="image"
              v-if="item.watermark.length>0"
              :src="url + item.watermark[0].fileUrl"
              alt="ཁུར་སྣོན་ནོར་འཁྲུལ།"
            />
            <img class="image" v-else src="" alt="གནས་སྐབས་པར་རིས་མེད་།" />
            <div class="ItemBody">
              <img
                class="imageHead"
                v-if="item.authorPicture"
                :src="url + item.authorPicture.thinUrl"
              />
              <span class="noneImage" v-else></span>
              <div class="ItemBody_name">{{ item.zangName }}</div>
            </div>
          </div>
        </div>
        <div class="noMessage hidden-xs-only" v-if="cardList.length == 0 && !loading">
          གནས་སྐབས་གཞི་གྲངས་མེད་པ་
        </div>
        <div class="waterfallBox hidden-sm-and-up">
          <div
            class="mobileExhibitionSearchItem"
            @click="goDetail(item.id)"
            v-for="(item, index) in cardListMobile"
            :key="index"
          >
            <img
              class="image"
              v-if="item.watermark.length>0"
              :src="url + item.watermark[0].fileUrl"
              alt="ཁུར་སྣོན་ནོར་འཁྲུལ།"
            />
            <img class="image" v-else src="" alt="གནས་སྐབས་པར་རིས་མེད་།" />
            <div class="ItemBody">
              <img
                class="imageHead"
                v-if="item.authorPicture"
                :src="url + item.authorPicture.thinUrl"
              />
              <span class="noneImage" v-else></span>
              <div class="ItemBody_name">{{ item.zangName }}</div>
            </div>
          </div>
          <div
            class="noMessage hidden-sm-and-up"
            v-if="cardListMobile.length == 0 && !loading"
          >
            གནས་སྐབས་གཞི་གྲངས་མེད་པ་
          </div>
        </div>
        <div
          class="loading"
          v-loading="loading"
          element-loading-text="གཞི་གྲངས་སྣོན་འཇུག་ཁྲོད་"
          element-loading-spinner="el-icon-loading"
        ></div>
      </div>
      <img
        class="CloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="exhibitionSearchBottom">
      <div class="section wow animate__fadeInUp animate__animated">
        <div class="customMadeLeft">
          <div class="high">རྩེར་སོན་གཏན་སྲོལ་</div>
          <p>
            ཁྱད་བཟོའི་གསལ་བཤད།
            ཁྱད་བཟོ་ཞེས་པ་ནི་མགྲོན་པོ་སོ་སོའི་ལུས་ཚད་དང་བསྟུན་ནས་དྲས་གཅོད་བྱས་པ་ལ་གོ
            །སེ་ཝེ་ཨར་སྲང་ལམ་ནི་ལུན་ཏུན་དཀྱིལ་དབུས་ཀྱི་མེ་ཧྥེ་ཨར་གྱི་དངོས་པོ་ཉོ་སའི་སྲང་ལམ་ཞིག་ཡིན་ལ།
            སྲོལ་རྒྱུན་གྱི་སྐྱེས་པའི་ལྭ་བ་ཁྱད་བཟོ་བྱས་པ་ལ་བརྟེན་ནས་མིང་དུ་གྲགས།
            དུས་ཀྱི་འཕེལ་རྒྱས་དང་བསྟུན་ནས"ཁྱད་བཟོ"ཞེས་པའི་ཐ་སྙད་ཀྱི་ནང་དོན་ཡང་ཕུན་སུམ་ཚོགས་པར་གྱུར།
            དཔེར་ན། གྱོན་ཆས་ཁྱད་བཟོ་དང་ལེགས་སྐྱེས་ཁྱད་བཟོ། ཐ་ན་ཤ་མདོག་ཁྱད་བཟོ།
            སྔོ་ཚལ་ཁྱད་བཟོ་སོགས་བྱུང་ཡོད་ལ།
            མི་རྣམས་ཀྱི་སྤུས་ལེགས་ཐོན་རྫས་དོན་གཉེར་དང་རང་གཤིས་དོད་པའི་སེམས་ཁམས་དང་མཐུན་པས།
            ཁྱད་བཟོ་ནི་རང་གཤིས་མངོན་པའི་འཛད་སྤྱོད་ཀྱི་རྣམ་པ་ངོ་མ་དེ་ཡིན།
          </p>
        </div>
        <div class="customMadeRight za_customMadeRight">
          <div>འཕྲལ་དུ་ཆེད་གཏོགས་ཁྱད་བཟོ་ཁྱད་བཟོ་བྱེད་པ།</div>
        </div>
      </div>
    </div>
    <!-- 公共底部 -->
    <common-bottom></common-bottom>
    <div class="contact">
      <div class="made" @click="goExhibitionMade()">
        <img src="../../assets/exhibitionsale/user.png" alt />
        <div>གཏན་ཁེལ།</div>
      </div>
      <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
        <div class="tel">སྦྲགས་ཡིག：hn_regong_ca@163.com</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>འབྲེལ་གཏུག་</div>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
  <div class="home" v-else>
    <!-- PC头部 -->
    <div class="homeTop hidden-xs-only">
       <Pic-top></Pic-top>
      <div class="homeTopList">
        <div class="left">
          <div class="navbar_dropdown_group" @click="handleChange(1)">
            <router-link to="index" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 1 ? 'selected' : 'sele'"
              >
                首页
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(2)">
            <router-link to="exhibition" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 2 ? 'selected' : 'sele'"
              >
                热贡作品展
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(4)">
            <router-link to="exhibitionSale" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 4 ? 'selected' : 'sele'"
              >
                热贡作品展销
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(5)">
            <router-link to="culture" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 5 ? 'selected' : 'sele'"
              >
                文创设计与展销
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(3)">
            <router-link to="database" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 3 ? 'selected' : 'sele'"
              >
                数据库
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(12)">
            <router-link to="inherit" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 12 ? 'selected' : 'sele'"
              >
                传承人
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(9)">
            <router-link to="news" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 9 ? 'selected' : 'sele'"
              >
                新闻动态
              </div>
            </router-link>
          </div>
          <div class="navbar_dropdown_group" @click="handleChange(10)">
            <router-link to="about" active-class="tarbar" class="tar">
              <div
                class="tarbar_title"
                :class="active == 10 ? 'selected' : 'sele'"
              >
                关于我们
              </div>
            </router-link>
          </div>
          <div class="searchInput hidden-xs-only">
            <el-select
              :popper-append-to-body="false"
              popper-class="select-popper"
              v-model="Info.type"
              placeholder="请选择"
              @change="handleSelectChange"
            >
              <el-option
                v-for="item in typeChineseList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input v-if="Info.type == 1||Info.type == 2||Info.type == ''" v-model="Info.name" @input="handleInputChange" placeholder="请输入内容"></el-input>
            <el-select
              v-else
              popper-class="select-popper"
              class="inheritor" 
              @focus="clearReadonly"
              @hook:mounted="clearReadonly"
              @visible-change="clearReadonly"
              ref="agentSelect"
              @change="handleInheritChange()" clearable v-model="Info.inheritorId" filterable placeholder="请输入内容">
              <el-option
                v-for="item in inheritData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <div class="searchButton" v-if="Info.type == 1||Info.type == 2" @click="handSearchOther()">
              <img src="../../assets/newImageBgc/search.png" alt="" />
            </div>
          </div>
          <div class="change">
            <el-select :popper-append-to-body="false" popper-class="select-popper" @change="changePCLanguages()" v-model="language" placeholder="请选择">
              <el-option
                v-for="item in languageList"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机版头部 -->
    <div class="menu_mobile hidden-sm-and-up">
      <div class="header_mobile_title">
        <img
          class="backImg"
          @click="goBack"
          src="../../assets/mobile/back.png"
          alt=""
        />
        <el-select
          :popper-append-to-body="false"
          popper-class="select-popper"
          v-model="mobileInfo.type"
          placeholder="请选择"
          @change="handleSelectChange"
        >
          <el-option
            v-for="item in typeChineseList"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-if="mobileInfo.type == 1||mobileInfo.type == 2||mobileInfo.type == ''"
          class="searchMobileInput"
          placeholder="请输入内容"
          v-model="mobileInfo.name"
          @input="handleInputMobileChange"
        >
        </el-input>
        <el-select
          v-else
          popper-class="select-popper"
          class="inheritor"
          @focus="clearReadonly"
          @hook:mounted="clearReadonly"
          @visible-change="clearReadonly"
          ref="agentSelect" 
          @change="handleInheritChange()" clearable v-model="mobileInfo.inheritorId" filterable placeholder="请输入内容">
          <el-option
            v-for="item in inheritData"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="searchButton" @click="mobileSearch">搜索</div>
      </div>
      <!-- 导航栏 -->
      <div class="header_mobile_content" style="display: none">
        <div class="mobile_content_top">
          <span></span>
        </div>
        <div class="mobile_content_middle">
          <div>
            <div @click="handleChange(1)">
              <router-link to="index">首页</router-link>
            </div>
            <div @click="handleChange(2)">
              <router-link to="exhibition">热贡作品展</router-link>
            </div>
            <div @click="handleChange(4)">
              <router-link to="exhibitionSale">热贡作品展销</router-link>
            </div>
            <div @click="handleChange(5)">
              <router-link to="culture">文创设计与展销</router-link>
            </div>
            <div @click="handleChange(3)">
              <router-link to="database">数据库</router-link>
            </div>
            <div @click="handleChange(9)">
              <router-link to="news">新闻动态</router-link>
            </div>
            <div @click="handleChange(10)">
              <router-link to="about">关于我们</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <Pic-top></Pic-top>
    </div>
    <div class="dataBaseSearchTop hidden-xs-only">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale">热贡作品展销</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ pcsearchName }}</span>
        </div>
      </div>
    </div>
    <div class="dataBaseSearchTop hidden-sm-and-up">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibitionSale">热贡作品展销</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ pcsearchName }}</span>
        </div>
      </div>
    </div>
    <div class="dataBaseSearchContent">
      <div class="section">
        <!-- 分类 -->
        <div class="saleTopList">
          <div
            class="item"
            v-for="(item, index) in saleTopList"
            :key="index"
            @click="chooseCategory(item.id)"
          >
            <img class="img" :src="item.imgSrc" alt="" />
            <span class="title">{{ item.title }}</span>
            <div :class="isClick == item.id ? 'isClick' : ''"></div>
          </div>
        </div>
        <div class="waterfallBox hidden-xs-only" v-if="cardList.length !== 0">
          <div
            class="exhibitionSearchItem"
            @click="goDetail(item.id)"
            v-for="(item, index) in cardList"
            :key="index"
          >
            <img
              class="image"
              v-if="item.watermark.length>0"
              :src="url + item.watermark[0].fileUrl"
              alt="加载错误"
            />
            <img class="image" v-else src="" alt="暂无图片" />
            <div class="ItemBody">
              <img
                class="imageHead"
                v-if="item.authorPicture"
                :src="url + item.authorPicture.thinUrl"
              />
              <!-- <span v-else>暂无图片</span> -->
              <span class="noneImage" v-else></span>
              <div class="ItemBody_name">{{ item.chineseName }}</div>
            </div>
          </div>
        </div>
        <div class="noMessage hidden-xs-only" v-if="cardList.length == 0 && !loading">
          暂无数据
        </div>
        <div class="waterfallBox hidden-sm-and-up">
          <div
            class="mobileExhibitionSearchItem"
            @click="goDetail(item.id)"
            v-for="(item, index) in cardListMobile"
            :key="index"
          >
            <img
              class="image"
              v-if="item.watermark.length>0"
              :src="url + item.watermark[0].fileUrl"
              alt="加载错误"
            />
            <img class="image" v-else src="" alt="暂无图片" />
            <div class="ItemBody">
              <img
                class="imageHead"
                v-if="item.authorPicture"
                :src="url + item.authorPicture.thinUrl"
              />
              <!-- <span v-else>暂无图片</span> -->
              <span class="noneImage" v-else></span>
              <div class="ItemBody_name">{{ item.chineseName }}</div>
            </div>
          </div>
          <div
            class="noMessage hidden-sm-and-up"
            v-if="cardListMobile.length == 0 && !loading"
          >
            暂无数据
          </div>
        </div>
        <div
          class="loading"
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
        ></div>
      </div>
      <img
        class="CloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="exhibitionSearchBottom">
      <div class="section wow animate__fadeInUp animate__animated">
        <div class="customMadeLeft">
          <div class="high">高端定制</div>
          <p>
            定制说明：定制的意思是为个别客户量身剪裁。塞维尔街是一个在伦敦中央梅费尔的购物街区，因为传统的定制男士服装行业而闻名。随着时代的发展，“定制”一词的意义也逐渐被丰富起来，比如定制服装，礼品，甚至出现了定制肤色，制定蔬菜等，迎合了人们追求品质和个性的心理，定制才是真正的个性化消费。
          </p>
        </div>
        <div class="customMadeRight">
          <div>即刻定制专属定制</div>
        </div>
      </div>
    </div>
    <!-- 公共底部 -->
    <common-bottom></common-bottom>
    <div class="contact">
      <div class="made" @click="goExhibitionMade()">
        <img src="../../assets/exhibitionsale/user.png" alt="" />
        <div>作品定制</div>
      </div>
      <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">联系电话：{{templeContact}}</div>
        <div class="tel">邮件：hn_regong_ca@163.com</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>联系画院</div>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
import { productPage,inherit } from "../../api/management.js";
import CommonBottom from "../../components/commonbottom";
import "swiper/dist/css/swiper.min.css";
import { throttle } from 'lodash'
export default {
  computed: {
    myValue() {
      return this.$store.state.num;
    },
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    myValue: function (val) {
      this.active = val;
    },
    changeLanguage: function (val) {
      this.language = val;
    },
    "$route.path": {
      handler(toPath, fromPath) {
        if (toPath == "/index") {
          this.active = 1;
        } else if (
          toPath == "/exhibition" ||
          toPath == "/exhibitionDetail" ||
          toPath == "/exhibitionWorkDetail" ||
          toPath == "/paintingExhibition" ||
          toPath == "/exhibitionWork" ||
          toPath == "/exhibitionBaseDetail"
        ) {
          this.active = 2;
        } else if (
          toPath == "/exhibitionSale" ||
          toPath == "/exhibitionSearchDetail" ||
          toPath == "/exhibitionMade" ||
          toPath == "/exhibitionSaleSearchDetail" ||
          toPath == "/exhibitionSaleSearch"
        ) {
          this.active = 4;
        } else if (
          toPath == "/culture" ||
          toPath == "/culturalGoodsDetail" ||
          toPath == "/culturalMoreGoods" ||
          toPath == "/culturalCustomMade" ||
          toPath == "/culturalCustomSearchDetail" ||
          toPath == "/culturalCustomDetail"
        ) {
          this.active = 5;
        } else if (
          toPath == "/database" ||
          toPath == "/dataBaseWork" ||
          toPath == "/dataBaseDetail" ||
          toPath == "/dataBaseSearch"
        ) {
          this.active = 3;
        } else if (toPath == "/news" || toPath == "/newsDetail") {
          this.active = 9;
        } else if (toPath == "/about") {
          this.active = 10;
        }
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  components: {
    PicTop,
    CommonBottom,
  },
  data() {
    return {
      url: process.env.VUE_APP_WEB_URL,
      active: 4,
      searchContent: "",
      pcsearchName: "全部",
      eng_pcsearchName: "All",
      za_pcsearchName: "ཡོངས་རྫོགས།",
      mobilesearchName: "全部",
      showBaseSearch: false,
      cardList: [],
      cardListMobile: [],
      total: null,
      mobileTotal: null,
      //作品PC
      Info: {
        name: this.$route.query.name? this.$route.query.name : "",
        type: this.$route.query.type? Number(this.$route.query.type) : '',
        current: 1,
        pageSize: 12,
        saleSeen: true,
        category:this.$route.query.category? Number(this.$route.query.category) : '',
        inheritorId:this.$route.query.inheritorId? Number(this.$route.query.inheritorId) : ""
      },
      //作品Mobile
      mobileInfo: {
        name: this.$route.query.name? this.$route.query.name : "",
        type: this.$route.query.type? Number(this.$route.query.type) : '',
        current: 1,
        pageSize: 6,
        saleSeen: true,
        category:this.$route.query.category? Number(this.$route.query.category) : '',
        inheritorId:this.$route.query.inheritorId? Number(this.$route.query.inheritorId) : ""
      },
      language: this.$store.state.language,
      loading: false,
      languageList:[
        {
          id:1,
          value: 'cn',
          label: '中文'
        },
        {
          id:2,
          value: 'en',
          label: 'བོད་ཡིག །'
        },
        {
          id:3,
          value: 'eng',
          label: 'English'
        }
      ],
       typeChineseList: [
        {
          id: 1,
          value: 1,
          label: "作品",
        },
        {
          id: 2,
          value: 2,
          label: "画院",
        },
        {
          id: 3,
          value: 3,
          label: "传承人",
        },
      ],
      typeZangList: [
        {
          id: 1,
          value: 1,
          label: "བརྩམས་ཆོས་",
        },
        {
          id: 2,
          value: 2,
          label: "རི་མོའི་ཁང་།",
        },
        {
          id: 3,
          value: 3,
          label: "རྒྱུན་འཛིན་པ།",
        },
      ],
      typeEnglishList: [
        {
          id: 1,
          value: 1,
          label: "Exhibition",
        },
        {
          id: 2,
          value: 2,
          label: "Painting Academy",
        },
        {
          id: 3,
          value: 3,
          label: "Inheritor",
        },
      ],
      templeContact:'13327681876',
      //分类
      saleTopList: [
        {
          imgSrc: require("../../assets/exhibitionImage/One.jpg"),
          title: "唐\xa0\xa0\xa0卡",
          za_title: "ཐང་ག",
          id: 1,
          eng_title: "Thangka",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/Two.jpg"),
          title: "泥\xa0\xa0\xa0塑",
          za_title: "འཇིམ་བཟོ། ",
          id: 2,
          eng_title: "Clay sculpture",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/Three.jpg"),
          title: "壁\xa0\xa0\xa0画",
          za_title: "ལྡེབས་རིས།",
          id: 3,
          eng_title: "Mural",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/Four.jpg"),
          title: "堆\xa0\xa0\xa0绣",
          za_title: "དྲས་དྲུབ།",
          id: 4,
          eng_title: "Pile embroidery",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/Five.jpg"),
          title: "彩\xa0\xa0\xa0绘",
          za_title: "ཚོན་རིས།",
          id: 5,
          eng_title: "Paintings",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/all.png"),
          title: "其\xa0\xa0\xa0他",
          za_title: "ཡོངས་རྫོགས།",
          id: 6,
          eng_title: "Other",
        },
      ],
      isClick:this.$route.query.category? Number(this.$route.query.category) : '',
      isMobile: false,
      inheritData:[],
    };
  },
  mounted() {
    this.getPCorMobile();
  },
  created() {
    this.changeLanguages();
    this.getInheritData()
    this.getCategroryName()
  },
  methods: {
    clearReadonly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          setTimeout(() => {
            const Selects = this.$refs
            if (Selects.agentSelect) {
              const input = Selects.agentSelect.$el.querySelector('.el-input__inner')
              input.removeAttribute('readonly')
            }
          })
        }
      })
    },
    // 搜索分类
    handleSelectChange() {
      if(this.isMobile) {
        if(this.mobileInfo.type==1||this.mobileInfo.type==2) {
          this.mobileInfo.inheritorId = ''
          this.mobileInfo.name = ''
        }
      } else {
        if(this.Info.type==1||this.Info.type==2) {
          this.Info.inheritorId = ''
          this.Info.name = ''
        }
      }
    },
    handleInheritChange() {
      // 通过id获取名称
      let name = ''
      if(this.isMobile) {
        this.inheritData.forEach(item => {
          if(item.id == this.mobileInfo.inheritorId) {
            name = item.name
          }
        })
      } else {
        this.inheritData.forEach(item => {
          if(item.id == this.Info.inheritorId) {
            name = item.name
          }
        })
      }
      if(this.isMobile) {
        this.mobileInfo.current = 1;
        this.cardListMobile = [];
        this.mobileTotal = null
        this.mobileInfo.name = name
        setTimeout(() => {
          this.getMobileProductPage();
        }, 200);
      } else {
        this.cardList = [];
        this.Info.current = 1;
        this.total = null;
        this.Info.name = name
        setTimeout(() => {
          this.getProductPage();
        }, 200);
      }
    },
    handleInputChange() {
      let message = ''
      if(this.language=='en') {
        message = 'སྔོན་ལ་འཚོལ་བཤེར་རིགས་འདེམས་རོགས་།'
      } else if(this.language=='eng') {
        message = 'Please select the search type first'
      } else {
        message = '请先选择搜索类型'
      }
      if (!this.Info.type) {
        this.$message({
          message: message,
          type: "error",
        });
        this.Info.name = "";
      }
    },
    handleInputMobileChange() {
      let message = ''
      if(this.language=='en') {
        message = 'སྔོན་ལ་འཚོལ་བཤེར་རིགས་འདེམས་རོགས་།'
      } else if(this.language=='eng') {
        message = 'Please select the search type first'
      } else {
        message = '请先选择搜索类型'
      }
      if (!this.mobileInfo.type) {
        this.$message({
          message: message,
          type: "error",
        });
        this.mobileInfo.name = "";
      }
    },
    //分类
    chooseCategory(id) {
      // 判断isClick是否有值，有相同的值清空，值不同就赋值，没有则赋值
      if(this.isMobile) {
        if (this.isClick == id) {
          this.isClick = 0
          this.mobileInfo.category = ''
        } else {
          this.isClick = id;
          this.mobileInfo.category = id
        }
        this.getCategroryName()
        this.cardListMobile = [];
        this.mobileTotal = null;
        this.mobileInfo.current = 1
        setTimeout(() => {
          this.getMobileProductPage();
        }, 300);
      } else {
        if (this.isClick == id) {
          this.isClick = 0
          this.Info.category = ''
        } else {
          this.isClick = id;
          this.Info.category = id
        }
        this.getCategroryName()
        this.cardList = [];
        this.total = null;
        this.Info.current = 1
        setTimeout(() => {
          this.getProductPage();
        }, 300);
      }
    },
    // 获取分类名称
    getCategroryName() {
      let category = ''
      if(this.isMobile) {
        category = this.mobileInfo.category
      } else {
        category = this.Info.category
      }
      if(category) {
        if(category==1) {
          this.pcsearchName = "唐卡";
          this.eng_pcsearchName = "Thangka";
          this.za_pcsearchName = "ཐང་ག";
        } else if(category==2) {
          this.pcsearchName = "泥塑";
          this.eng_pcsearchName = "Clay sculpture";
          this.za_pcsearchName = "འཇིམ་བཟོ།";
        } else if(category==3) {
          this.pcsearchName = "壁画";
          this.eng_pcsearchName = "Mural";
          this.za_pcsearchName = "ལྡེབས་རིས།";
        } else if(category==4) {
          this.pcsearchName = "堆绣";
          this.eng_pcsearchName = "Pile embroidery";
          this.za_pcsearchName = "དྲས་དྲུབ།";
        } else if(category==5) {
          this.pcsearchName = "彩绘";
          this.eng_pcsearchName = "Paintings";
          this.za_pcsearchName = "ཚོན་རིས།";
        } else if(category==6) {
          this.pcsearchName = "其他";
          this.eng_pcsearchName = "Other";
          this.za_pcsearchName = "ཡོངས་རྫོགས།";
      } else {
        this.pcsearchName = "全部";
        this.eng_pcsearchName = "All";
        this.za_pcsearchName = "ཡོངས་རྫོགས།";
      }
      }
    },
    goDetail(id) {
      let type = ''
      let name = ''
      let category = ''
      let inheritorId = ''
      if(this.isMobile) {
        type = this.mobileInfo.type
        name = this.mobileInfo.name
        category = this.mobileInfo.category
        inheritorId = this.mobileInfo.inheritorId
      } else {
        type = this.Info.type
        name = this.Info.name
        category = this.Info.category
        inheritorId = this.Info.inheritorId
      }
      this.$router.push({
        path: "/exhibitionSaleSearchDetail",
        query: { 
          id: id ,
          type: type,
          name: name,
          category: category,
          inheritorId: inheritorId
        },
      });
    },
    //作品定制
    goExhibitionMade() {
      this.$router.push("/exhibitionMade");
    },
    handleChange(num) {
      if (num <= 5) {
        this.$store.commit("changeNum", num);
      } else if (num == 9) {
        this.$store.commit("changeNum", num);
      } else if (num == 10) {
        this.$store.commit("changeNum", num);
      }
      if (num == 1) {
        this.$store.commit("changeTitle", "美梦成真");
        this.showBaseSearch = false;
      } else if (num == 2) {
        this.$store.commit("changeTitle", "殿堂大师作品展");
        this.showBaseSearch = false;
      } else if (num == 3) {
        this.$store.commit("changeTitle", "热贡泥塑数据库");
        this.showBaseSearch = false;
      } else if (num == 4) {
        this.$store.commit("changeTitle", "名家作品展销");
        this.showBaseSearch = false;
      } else if (num == 5) {
        this.$store.commit("changeTitle", "AI辅助文创定制");
        this.showBaseSearch = false;
      } else if (num == 6) {
        this.$router.push("/exhibitionSearch");
        this.showBaseSearch = false;
      } else if (num == 7) {
        this.$router.push("/dataBaseSearch");
        this.showBaseSearch = true;
      }
    },
    goBack() {
      this.$router.push("/exhibitionSale");
    },
    //作品列表
    async getProductPage() {
      this.loading = true;
      const res = await productPage(
        {
          type: this.Info.type,
          name: this.Info.type==3?'':this.Info.name,
          category: this.Info.category,
          inheritorId: this.Info.inheritorId,
          current: this.Info.current,
          pageSize: this.Info.pageSize,
          saleSeen: this.Info.saleSeen,
        }
      );
      if (res.code == 1) {
        this.loading = false;
        this.cardList = this.cardList.concat(res.data.records);
        this.total = res.data.total;
      }
    },
    //搜索
    handSearchOther() {
      // this.pcsearchName = this.Info.name;
      this.cardList = [];
      this.Info.current = 1;
      this.total = null;
      // if (this.Info.name == "") {
      //   this.pcsearchName = "全部";
      //   this.eng_pcsearchName = "All";
      //   this.za_pcsearchName = "ཡོངས་རྫོགས།";
      // }
      setTimeout(() => {
        this.getProductPage();
      }, 200);
    },
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.getMobileProductPage();
        this.isMobile = true;
        window.addEventListener("scroll", this.Scrollbottom, true);
      } else {
        this.getProductPage();
        this.isMobile = false;
        window.addEventListener("scroll", this.PCscrollBottom, true);
      }
    },
    PCscrollBottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //到底后要去触发的事件
        if (this.Info.current * 12 >= this.total)
          return this.$message("数据加载完毕");
        this.loading = true;
        setTimeout(() => {
          this.Info.current++;
          this.getProductPage();
        }, 1000);
      }
    },1000),
    Scrollbottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight + 500 >= scrollHeight) {
        //到底后要去触发的事件
        if (this.mobileInfo.current * 6 >= this.mobileTotal)
          return this.$message("数据加载完毕");
        this.loading = true;
        setTimeout(() => {
          this.mobileInfo.current++;
          this.getMobileProductPage();
        }, 1000);
      }
    },2000),
    async getMobileProductPage() {
      this.loading = true;
      const res = await productPage(
        {
          type: this.mobileInfo.type,
          name: this.mobileInfo.type==3?'':this.mobileInfo.name,
          category: this.mobileInfo.category,
          inheritorId: this.mobileInfo.inheritorId,
          current: this.mobileInfo.current,
          pageSize: this.mobileInfo.pageSize,
          saleSeen: this.mobileInfo.saleSeen,
        }
      );
      if (res.code == 1) {
        this.loading = false;
        this.cardListMobile = this.cardListMobile.concat(res.data.records);
        this.mobileTotal = res.data.total;
      }
    },
    mobileSearch() {
      // this.mobilesearchName = this.mobileInfo.name;
      this.mobileInfo.current = 1;
      this.cardListMobile = [];
      this.mobileTotal = null
      // if (this.mobileInfo.name == "") {
      //   this.mobilesearchName = "全部";
      // }
      setTimeout(() => {
        this.getMobileProductPage();
      }, 200);
    },
    changeLanguages(num) {
      if (num == 1) {
        this.language = "en";
        this.$store.commit("changeLanguage", this.language);
      } else if (num == 2) {
        this.language = "cn";
        this.$store.commit("changeLanguage", this.language);
      } else if (num == 3) {
        this.language = "eng";
        this.$store.commit("changeLanguage", this.language);
      }
    },
    changePCLanguages() {
      let language = this.language
      this.$store.commit("changeLanguage", language);
      this.getInheritData()
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
    async getInheritData() {
      const res = await inherit(
        {
          current: 1,
          pageSize:1000
        }
      )
      if (res.code == 1) {
        if(res.data.records.length>0) {
          let list = []
          res.data.records.forEach(item => {
            let name = ''
            let templeName = ''
            if(this.language=='eng') {
              name = item.englishName
              templeName = item.templeEnglishName? '-'+item.templeEnglishName : ''
            } else if(this.language=='en') {
              name = item.zangName
              templeName = item.templeZangName? '-'+item.templeZangName : ''
            } else {
              name = item.chineseName
              templeName = item.templeName? '-'+item.templeName : ''
            }
            list.push({
              id: item.id,
              name: name+templeName,
            })
          })
          this.inheritData = list;
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.PCscrollBottom, true);
    window.removeEventListener("scroll", this.Scrollbottom, true);
  },
};
</script>
<style lang="scss" scoped>
.home {
  position: relative;
  /deep/.homeTop {
    position: relative;
    font-family: "fangzang";
    .homeTopList {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      display: flex;
      width: 100%;
      height: 50px;
      background-color: #10161e;
      opacity: 0.9;
      .left {
        font-family: "fangzang";
        width: 100%;
        // position: absolute;
        // top: 0;
        // left: 9%;
        align-items: center;
        height: 50px;
        display: flex;
        white-space: nowrap;
        justify-content: center;
        .navbar_dropdown_group {
          margin-left: 0.3rem;
          a {
            display: inline-block;
            text-align: center;
            font-size: 16px;
            color: #fff;
            transition: all 0.3s ease;
            &:hover {
              color: #feae03;
            }
            .tarbar_title {
              height: 50px;
              line-height: 50px;
            }
          }
          .tar {
            .tarbar_title {
              border-bottom: 0;
            }
            .selected {
              border-bottom: 4px solid #ed201a;
            }
          }
          //记住切不可将router-link-exact-active与tar调换位置
          .router-link-exact-active {
            .selected {
              border-bottom: 4px solid #ed201a;
            }
          }
        }
        .navbar_dropdown_group:first-child {
          margin-left: 0;
        }
        .dataBase {
          cursor: pointer;
          font-size: 16px;
          margin-left: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          img {
            vertical-align: middle;
          }
          .goLogin {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-right: 15px;
            .userImg {
              position: relative;
              margin-left: 15px;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 30px;
              width: 30px;
              background-color: #931217;
              border-radius: 100%;
              .loginBox {
                display: none;
              }
            }
            .userImg:hover {
              .loginBox {
                border-radius: 4px;
                display: block;
                position: absolute;
                top: 30px;
                left: -8px;
                width: 48px;
                height: 32px;
                background-color: #fff;
                font-size: 14px;
                color: #10161e;
                font-family: none;
                .loginBox_top {
                  text-align: center;
                  padding: 6px 0;
                }
                .loginBox_bottom {
                  text-align: center;
                  padding: 6px 0;
                }
              }
            }
          }
          .OutLogin {
            display: flex;
            justify-content: center;
            align-items: center;
            .userImg {
              position: relative;
              margin: 0 15px;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 30px;
              width: 30px;
              background-color: #971118;
              border-radius: 100%;
              .loginBox {
                display: none;
              }
            }
            .userImg:hover {
              .loginBox {
                border-radius: 4px;
                display: block;
                position: absolute;
                top: 30px;
                left: -8px;
                width: 48px;
                height: 32px;
                background-color: #fff;
                font-size: 14px;
                color: #10161e;
                font-family: none;
                .loginBox_top {
                  text-align: center;
                  padding: 6px 0;
                }
                .loginBox_bottom {
                  text-align: center;
                  padding: 6px 0;
                }
              }
            }
          }
          .Search {
            display: flex;
            .search {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 30px;
              width: 30px;
              background-color: #971118;
              border-radius: 100%;
            }
            .iconSearch {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .change {
          margin-left: 0.1rem;
          display: flex;
          align-items: center;
          .el-select {
            width: 90px;
            height: 30px;
            .el-input {
              .el-input__inner{
                height: 30px;
                text-align: center;
                background-color: #550a0d;
                border: none;
                color: #fff;
              }
              .el-input__suffix{
                .el-input__suffix-inner{
                  .el-select__caret{
                    color: #fff;
                  }
                  .el-input__icon {
                    height: 30px;
                    line-height: 30px;
                  }
                }
              }
            }
            .select-popper {
              .el-scrollbar {
                .el-select-dropdown__wrap{
                  .el-scrollbar__view {
                    .selected{
                      color: #550a0d;
                    }
                  }
                }

              }
            }
          }
        }
        .searchInput {
          position: relative;
          margin-left: .2rem;
          display: flex;
          // align-items: center;
          .el-select {
            width: 90px;
            height: 34px;
            .el-input {
              .el-input__inner {
                width: 90px;
                height: 30px;
                text-align: center;
                background-color: #550a0d;
                border: none;
                color: #fff;
              }
              .el-input__suffix {
                .el-input__suffix-inner {
                  .el-select__caret {
                    color: #fff;
                  }
                  .el-input__icon {
                    height: 34px;
                    line-height: 34px;
                  }
                }
              }
            }
            .select-popper {
              .el-scrollbar {
                .el-select-dropdown__wrap {
                  .el-scrollbar__view {
                    .selected {
                      color: #550a0d;
                    }
                  }
                }
              }
            }
          }
          .el-input__inner {
            height: 34px !important;
            width: 170px;
            color: #99131a;
            padding: 0 30px 0 15px;
          }
          .searchButton {
            cursor: pointer;
            position: absolute;
            top: 12%;
            right: 1%;
            img {
              height: 26px;
            }
          }
          .inheritor {
            width: 170px!important;
            .el-input__inner {
              width: 100%!important;
              background-color: #ffffff!important;
              text-align: left!important;
              color: #550a0d!important;
            }
          }
        }
      }
      .za_left {
        // left: 8%;
        .navbar_dropdown_group {
          margin-left: 0.1rem;
          a {
            font-size: 18px;
          }
        }
        .dataBase {
          margin-left: 50px;
        }
        .change {
          margin-left: .1rem;
        }
        .searchInput {
          margin-left: .1rem;
        }
      }
      .eng_left {
        font-family: "Times New Roman", Times, serif;
        // left: 9%;
        .navbar_dropdown_group {
          margin-left: 0.05rem;
          a {
            font-size: 13px;
          }
        }
        .dataBase {
          margin-left: .05rem;
          font-size: 13px;
        }
        .change {
          margin-left: .05rem;
          .changeBox {
            font-family: "fangzang";
          }
        }
        .searchInput {
          margin-left: .05rem;
          .el-input__inner {
            width: 140px;
          }
          .inheritor {
            width: 140px!important;
            .el-input__inner {
              width: 100%!important;
              // background-color: #ffffff!important;
              // text-align: left!important;
              // color: #550a0d!important;
            }
          }
        }
      }
    }
    .sections {
      display: flex;
      margin: 0 auto;
      justify-content: center;
      .indexTopRight {
        background: url("../../assets/indexImage/indexTopRightRed.png")
          no-repeat center;
        background-size: cover;
        height: 680px;
        width: 488px;
        font-family: "fangzang";
        display: flex;
        justify-content: center;
        align-items: center;
        writing-mode: tb-rl;
        div {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column-reverse;
          color: #fff;
          .hot_art {
            font-size: 70px;
          }
          .dream {
            font-size: 50px;
          }
        }
      }
    }
  }
  .dataBaseSearchTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
  }
  .dataBaseSearchContent {
    position: relative;
    padding-top: 50px;
    .section {
      .saleTopList {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 50px;
        .item {
          cursor: pointer;
          height: 110px;
          //间隙控制
          // margin-right: 4px;
          position: relative;
          .title {
            white-space: nowrap;
            position: absolute;
            color: #fff;
            font-family: "fangzang";
            font-size: 20px;
            z-index: 99;
            right: 10px;
           bottom: 2px;
          }
          .eng_title {
            font-size: 17px;
            bottom: 4px;
            font-family: "Times New Roman", Times, serif;
          }
          .img {
            height: 110px;
          }
        }
        .isClick {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0.7;
          background-color: #304462;
        }
      }
      .waterfallBox {
        display: flex;
        flex-wrap: wrap;
        .exhibitionSearchItem {
          overflow: hidden;
          padding: 4px;
          width: 22.5%;
          margin-right: 40px;
          margin-bottom: 50px;
          .image {
            display: block;
            height: 350px;
            width: 100%;
            transition: all 500ms ease;
          }
          .ItemBody {
            width: 100%;
            margin-top: 18px;
            display: flex;
            align-items: center;
            .imageHead {
              width: 45px;
              height: 45px;
              border-radius: 45px;
              margin-right: 10px;
            }
            .noneImage {
              margin-right: 10px !important;
              border-radius: 45px;
              width: 45px !important;
              height: 45px !important;
              border: 1px solid #e9e9e9;
            }
            .ItemBody_name {
              width: calc(100% - 55px);
              font-size: 18px;
              font-family: "fangzang";
              color: #374963;
              overflow: hidden; 
              display: -webkit-box;
              -webkit-line-clamp: 1;/* 限制在一个块元素中显示文本的行数 */
              -webkit-box-orient: vertical;/* 设置伸缩盒子对象的子元素的排列方式 */
            }
          }
        }
        .exhibitionSearchItem:nth-child(4n) {
          margin-right: 0;
        }
        .exhibitionSearchItem:hover {
          box-shadow: 0 0 15px #a8a8a8;
          .image {
            transform: scale(1.05);
          }
        }
      }
      .noMessage {
        margin: 20px 0;
        letter-spacing: 4px;
        font-weight: bold;
        font-size: 24px;
        text-align: center;
      }
    }
    /deep/.loading {
      margin-bottom: 20px;
      .el-loading-mask {
        .el-loading-spinner {
          .el-icon-loading {
            color: #ef3731;
          }
          .el-loading-text {
            color: #ef3731;
          }
        }
      }
    }
    .CloudLeft {
      position: absolute;
      top: -50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .exhibitionSearchBottom {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-position: 100% 90%;
    background-size: 7%;
    margin-bottom: 50px;
    position: relative;
    .section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #f5f5f5;
      padding: 30px 40px;
      .customMadeLeft {
        width: 80%;
        padding-right: 20px;
        .high {
          font-size: 32px;
          font-family: "fangzang";
        }
        .eng_high {
          font-family: "Times New Roman", Times, serif;
        }
        p {
          letter-spacing: 1px;
          font-size: 16px;
          line-height: 1.5;
          text-align: justify;
        }
      }
      .customMadeRight {
        div {
          white-space: nowrap;
          background-color: #931217;
          font-size: 32px;
          font-family: "fangzang";
          color: #fff;
          padding: 10px;
          letter-spacing: 2px;
          border-radius: 6px;
        }
      }
      .eng_customMadeRight {
        div {
          font-size: 16px;
        }
      }
      .za_customMadeRight {
        div {
          font-size: 20px;
        }
      }
    }
  }
  // 手机
  .menu_mobile {
    .header_mobile_title {
      height: 1.1rem;
      box-shadow: 0 2px 2px #d8d9da;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding: 0 0.1rem;
      img {
        width: 0.5rem;
        height: 0.5rem;
        pointer-events:auto;
      }
      h2 {
        text-align: center;
        font-weight: 400;
        font-size: 0.345rem;
      }
      span {
        width: 0.5rem;
        height: 0.5rem;
      }
      .backImg {
        width: 0.4rem;
        height: 0.4rem;
        z-index: 999;
      }
      /deep/.el-select {
        width: 2rem;
        height: 0.6rem;
        .el-input {
          .el-input__inner {
            font-size: .28rem;
            width: 2rem;
            height: 0.6rem;
            text-align: center;
            border-radius: 1rem;
            color: #550a0d;
          }
          .el-input__suffix {
            right: 0;
            .el-input__suffix-inner {
              .el-select__caret {
                color: #550a0d;
              }
              .el-input__icon {
                height: 0.6rem;
                line-height: 0.6rem;
              }
            }
          }
        }
        .select-popper {
          .el-scrollbar {
            .el-select-dropdown__wrap {
              .el-scrollbar__view {
                .selected {
                  color: #550a0d;
                }
              }
            }
          }
        }
      }
      /deep/.searchMobileInput {
        position: relative;
        height: 0.6rem;
        width: 3.5rem;
        border: none;
        .el-input__inner {
          height: 0.6rem;
          width: 3.5rem;
          color: #99131a;
          border-radius: 1rem;
          text-align: center;
          background-color: #f5f5f5;
        }
        .el-input__icon {
          text-align: center;
          line-height: 0.6rem;
          position: absolute;
          left: 1.3rem;
        }
      }
      .searchButton {
        height: 0.6rem;
        line-height: 0.6rem;
        width: 1rem;
        background-color: #971118;
        color: #fff;
        text-align: center;
        border-radius: 0.3rem;
        font-size: .3rem;
      }
      .titleRight {
        .userSearch {
          display: flex;
          .userSearch_Photo,
          .userSearch_Search {
            width: 0.5rem;
            height: 0.5rem;
            background-color: #971118;
            border-radius: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 0.25rem;
              height: 0.3rem;
            }
          }
          .userSearch_Search {
            margin-left: 0.2rem;
            img {
              width: 0.3rem;
              height: 0.3rem;
            }
          }
        }
      }
      /deep/.inheritor {
        width: 3.5rem !important;
        .el-input__inner {
          width: 100%!important;
          color: #99131a!important;
          background-color: #f5f5f5!important;
        }
      }
    }
    .header_mobile_content {
      position: fixed;
      top: 0;
      background: rgba(65, 120, 190, 0.8);
      width: 100vw;
      height: 100vh;
      z-index: 999;
      .mobile_content_top {
        height: 1.2rem;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        width: 100%;
        span {
          padding-right: 1rem;
          display: inline-block;
          width: 0.4rem;
          height: 0.4rem;
          background: url("../../assets/mobile/cancle.png") center center
            no-repeat;
          transform: rotate(180deg);
        }
      }
      .mobile_content_middle {
        display: flex;
        justify-content: center;
        flex-direction: column;
        a {
          display: block;
          padding: 0 0.25rem;
          line-height: 0.9rem;
          font-size: 0.31rem;
          color: #fff;
          text-align: center;
        }
      }
    }
  }
  .el-dialog {
    width: 70% !important;
    .el-dialog__body {
      padding: 0 0.6rem;
    }
    .register {
      text-align: right;
    }
  }
  .contact {
    z-index: 99;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 20%;
    .made,
    .mobile {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      font-size: 12px;
      margin-bottom: 20px;
      box-shadow: 0 0 10px #99131a;
      border: none;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
}
@media (max-width: 768px) {
  .home {
    position: relative;
    .header_mobile_title {
      .eng_header_mobile_title {
        font-size: 0.1rem;
      }
    }
    .dataBaseSearchTop {
      position: relative;
      background: url("../../assets/newImage/index/could_left.png") no-repeat
        top left;
      background-position: 0 50%;
      background-size: 15%;
      .section {
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
    }
    .dataBaseSearchContent {
      padding-top: 0;
      margin: 0.5rem 0;
      .section {
          .saleTopList {
        display: flex;
        width: 100%;
        margin: 0 auto;
        flex-wrap: wrap;
        margin-bottom: 0!important;
        .item {
          height: 1.9rem !important;
          position: relative;
          overflow: hidden;
          margin-bottom: 0.48rem;
          width: 48%;
          .title {
            position: absolute;
            bottom: 0.08rem;
            right: .35rem;
            font-size: .32rem;
            color: #fff;
            font-family: "fangzang";
          }
          .eng_title {
            font-family: "Times New Roman", Times, serif;
            font-size: 0.25rem;
          }
          .img {
            height: 1.9rem!important;
            cursor: pointer;
            width: 100%;
            transition: all 1s ease;
          }
        }
        .item:nth-child(2n) {
          margin-right: 0;
        }
        .isClick {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 1.9rem;
          opacity: 0.7;
          background-color: #304462;
        }
      }
        .waterfallBox {
          display: flex;
          flex-wrap: wrap;
          .mobileExhibitionSearchItem {
            width: 3.2rem;
            margin-right: 0.6rem;
            margin-bottom: 0.5rem;
            .image {
              height: 4.2rem;
              width: 3.2rem;
            }
            .ItemBody {
              width: 100%;
              margin-top: 0.2rem;
              display: flex;
              align-items: center;
              .imageHead {
                width: 0.6rem;
                height: 0.6rem;
                border-radius: 0.6rem;
                margin-right: 0.1rem;
              }
              .noneImage {
                margin-right: 0.1rem !important;
                border-radius: 0.6rem;
                width: 0.6rem !important;
                height: 0.6rem !important;
                border: 1px solid #e9e9e9;
              }
              .ItemBody_name {
                width: calc(100% - 0.7rem);
                font-size: 0.25rem;
                overflow: hidden; 
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              }
            }
          }
          .mobileExhibitionSearchItem:nth-child(2n) {
            margin-right: 0;
          }
          .noMessage {
            width: 100%;
            margin: 20px 0;
            letter-spacing: 4px;
            font-weight: bold;
            font-size: 0.4rem;
            text-align: center;
          }
        }
        .noMessage {
          font-weight: bold;
          font-size: 0.3rem;
          text-align: center;
        }
      }
    }
    .contact {
      z-index: 2001;
      bottom: 35%;
      right: 1%;
      .made,
      .mobile {
        width: 1.7rem;
        height: 1.7rem;
        padding: 0.2rem;
        margin-bottom: 0.2rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
    }
    .exhibitionSearchBottom {
      background-position: 100% 100%;
      background-size: 15%;
      padding: 0 0.2rem .5rem 0.2rem;
      margin-bottom: 0;
      .section {
        display: flex;
        flex-direction: column;
        padding: 0.2rem 0;
        .customMadeLeft {
          padding: 0.2rem 0 0.5rem 0;
          .high {
            font-size: 0.4rem;
            text-align: center;
          }
          p {
            margin-top: 0.2rem;
            letter-spacing: 0;
          }
        }
        .customMadeRight {
          display: flex;
          justify-content: center;
          div {
            font-size: 0.4rem;
          }
        }
        .eng_customMadeRight {
          text-align: center;
          width: 4rem;
          div {
            font-size: 0.16rem;
          }
        }
        .za_customMadeRight > div {
          height: 0.7rem;
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>
